var HTMLStringDelegate   = require("enyo/HTMLStringDelegate");

/**
* [CanvasRenderDelegate]{@link enyo-canvas.CanvasRenderDelegate} is a modified
* version of `enyo.HTMLStringDelegate` which does not attempt to render any html
* for children of the Control. It is meant to be used as renderDelegate for
* [Canvas]{@link enyo-canvas.Canvas}.
*
* @module enyo-canvas.CanvasRenderDelegate
* @public
*/
module.exports = {

    /**
     * @method
     * @private
     */
    invalidate: HTMLStringDelegate.invalidate,

    /**
     * @method
     * @private
     */
    render: HTMLStringDelegate.render,

    /**
     * @method
     * @private
     */
    renderInto: HTMLStringDelegate.renderInto,

    /**
     * @method
     * @private
     */
    renderNode: HTMLStringDelegate.renderNode,

    /**
     * @method
     * @private
     */
    renderDom: HTMLStringDelegate.renderDom,

    /**
     * @method
     * @private
     */
    renderStyles: HTMLStringDelegate.renderStyles,

    /**
     * @method
     * @private
     */
    renderAttributes: HTMLStringDelegate.renderAttributes,

    /**
     * @method
     * @private
     */
    renderContent: function() {},

    /**
     * Render the canvas control, but do not attempt to render any of it's
     * children as html.
     *
     * @param   {enyo.Control}  control  The Canvas control
     * @return  {string}                 The html string of the canvas tag
     * @method
     * @private
     */
    generateHtml: function(control) {
        var html;

        if (control.canGenerate === false) {
            return "";
        }

        // Generate tag, styles, attributes
        html = this.generateOuterHtml(control, "");

        // NOTE: 'generated' is used to gate access to findNodeById in
        // hasNode, because findNodeById is expensive.
        // NOTE: we typically use 'generated' to mean 'created in DOM'
        // but that has not actually happened at this point.
        // We set 'generated = true' here anyway to avoid having to walk the
        // control tree a second time (to set it later).
        // The contract is that insertion in DOM will happen synchronously
        // to generateHtml() and before anybody should be calling hasNode().
        control.set("generated", true);

        return html;
    },

    /**
     * @method
     * @private
     */
    generateOuterHtml: HTMLStringDelegate.generateOuterHtml,

    /**
     * @method
     * @private
     */
    generateInnerHtml: function() {},

    /**
     * @method
     * @private
     */
    generateChildHtml: function() {},

    /**
     * @method
     * @private
     */
    prepareTags: HTMLStringDelegate.prepareTags,

    /**
     * @method
     * @private
     */
    attributesToHtml: HTMLStringDelegate.attributesToHtml,

    /**
     * @method
     * @private
     */
    escapeAttribute: HTMLStringDelegate.escapeAttribute,

    /**
     * @param  {enyo.Control}  control  The Canvas control
     * @method
     * @private
     */
    teardownRender: function(control) {
        if (control.generated) {
            if (typeof control.beforeTeardown === "function") {
                control.beforeTeardown();
            }
        }

        control.node = null;
        control.set("generated", false);
    },

    /**
     * @method
     * @private
     */
    teardownChildren: function() {}

};
